import { useState } from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import useJobTitle from './useJobTitle';
import useSearch from './useSearch';
import useRoute from './useRoute';
import useSwitch from 'Hooks/useSwitch';
import getColumns from '../columns';

const useDefinitionSelectJobTitle = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const { jobTitle } = useJobTitle(setIsLoading);
  const { setSearch, jobTitleFilters } = useSearch({ jobTitle });
  const { handlePage } = useRoute();

  const [selectedIds, setSelectedIds] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pageSize, setPageSize] = useState(15);
  const { active: dialogOpen, activate: openDialog, deactivate: closeDialog } = useSwitch();

  const shouldRedirect = location?.state?.isComingFrom !== '/definicion';

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleViewDetails = () => {
    if (!selectedRow) return;
    handlePage(selectedRow);
    handleMenuClose();
  };

  const handleSelectionChange = ids => setSelectedIds(ids);
  const handlePageSizeChange = newSize => setPageSize(newSize);
  const handleDialogSuccess = () => setSelectedIds([]);

  const columns = getColumns({ handleMenuOpen });

  return {
    shouldRedirect,
    isLoading,
    jobTitleFilters,
    selectedIds,
    anchorEl,
    pageSize,
    dialogOpen,
    columns,
    setSearch,
    openDialog,
    closeDialog,
    handleMenuClose,
    handleViewDetails,
    handleSelectionChange,
    handlePageSizeChange,
    handleDialogSuccess,
  };
};

export default useDefinitionSelectJobTitle;
